import state from './moduleBusinessState.js'
import mutations from './moduleBusinessMutations.js'
import actions from './moduleBusinessActions.js'
import getters from './moduleBusinessGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
